import React from 'react';
import { Box, Typography } from '@mui/material';
import { THEME } from './genesisData';
import MemoryIcon from '@mui/icons-material/Memory';

// Placeholder Memory page. The full "memory loop" archive (past jobs + what the
// system learned from them) is still being built; until it lands this renders a
// clean "coming soon" screen. Intentionally has NO data fetching, hooks, or field
// access — nothing here can throw, so the /memory route always renders.
const MemoryPage = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      color: THEME.textPrimary,
      fontFamily: '"IBM Plex Sans", -apple-system, sans-serif',
    }}
  >
    {/* HEADER BAR — matches the other enterprise-ai pages */}
    <Box
      sx={{
        borderBottom: `1px solid ${THEME.border}`,
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        flexShrink: 0,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
          Memory
        </Typography>
        <Typography variant="caption" sx={{ color: THEME.textMuted }}>
          The archive of past jobs and what the system learned from them.
        </Typography>
      </Box>
    </Box>

    {/* CENTERED COMING-SOON STATE */}
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: THEME.mintDim,
          mb: 2.5,
        }}
      >
        <MemoryIcon sx={{ fontSize: 28, color: THEME.mint }} />
      </Box>
      <Typography sx={{ fontSize: 22, fontWeight: 600, color: THEME.textPrimary }}>Memory</Typography>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: THEME.mint,
          mt: 1,
        }}
      >
        Coming soon
      </Typography>
      <Typography sx={{ fontSize: 13, color: THEME.textMuted, mt: 1.5, maxWidth: 420, lineHeight: 1.6 }}>
        The memory archive is on the way. This is where the system's past jobs and what it learned from them will live.
      </Typography>
    </Box>
  </Box>
);

export default MemoryPage;
